import React from 'react';
import i18next from 'i18next';
import styled, { css } from 'react-emotion';

import { Label } from '~/modules/coreUI/components/basic/Labels';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';
import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { scrollToContainerTop } from '~/modules/core/utils/jsHelpers/ScrollToTop';

const Icon = withDirection(styled.i`
  display: inline-block;
  ${props => (props.direction === 'rtl'
    && css`
        transform: rotate(-180deg);
  `)}
`);

const LinkContainer = styled(Row)`
  cursor: pointer;
`;

const SellingOptionLink = () => (
  <LinkContainer onClick={() => scrollToContainerTop('productTabs')}>
    <Column>
      <Label size="7px" secondary>
        <Icon className="el-icon el-icon-down-arrow-gray" />
      </Label>
      <Label size="7px" secondary>
        <Icon className="el-icon el-icon-down-arrow-gray" />
      </Label>
    </Column>
    <Label size={['xs', 'xs', 'md', 'md']} secondary sm>
      &nbsp;
      {i18next.t('ecommerceCoreUI:Product.buyingOptionsScrollLink')}
    </Label>
  </LinkContainer>
);

export default SellingOptionLink;
